export class CurrentMedicationModel {
patientcode = '' ;
cmdate = '2022-01-01' ;
drugref = '' ;
drugname = '' ;
dose = '' ;
uom = '' ;
route = '' ;
duration = '' ;
gencomplaint = '' ;
frequancy = '' ;
cmdate1 = '2022-01-01' ;
cmsource = '' ;
cmdoctor = '' ;
compcode = '' ;
userid = '' ;
modifieddate = '2022-01-01' ;
ittname = '' ;
unname = '' ;

}
